// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vscy","type":"styles_type__3GEkt","choices":"styles_choices__tKIfu"};